/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import pinia from '../store'
import api from './api'
import clipboard from './clipboard.plugin'
import keycloakPlugin from './keycloak.plugin'
import ghostPlugin from './ghost.plugin'
import router from '../router'
import emitter from './eventBus'

const {
    VITE_APP_KEYCLOAK_URL,
    VITE_APP_KEYCLOAK_REALM,
    VITE_APP_KEYCLOAK_CLIENT_ID,
} = import.meta.env

export function registerPlugins(app) {
    app
        .use(pinia)
        .use(keycloakPlugin, {
            keycloakConfig: {
                url: VITE_APP_KEYCLOAK_URL,
                realm: VITE_APP_KEYCLOAK_REALM,
                clientId: VITE_APP_KEYCLOAK_CLIENT_ID,
            },
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
            responseMode: 'query',
            pinia
        })
        .use(emitter)
        .use(router)
        .use(ghostPlugin)
        .use(vuetify)
        .use(api)
    app.provide('clipboard', clipboard)
}
